// eslint-disable-next-line import/prefer-default-export
export enum RestrictedActionTypes {
  marketplace = 'MARKETPLACE',
  silenced = 'SILENCED',
}
